import React, { Component } from 'react';
import T from 'i18n-react';
import { withFormik } from 'formik';
import Yup from 'yup';
import NumericRating from './NumericRating';
import StarRating from './StarRating';
import RadioButton from './RadioButton';
import InputFeedback from './InputFeedback';
import unlike from '../assets/img/unlike.png';
import like from '../assets/img/like.png';
import Spinner from './Spinner'

const TEXT_LIMIT_AMOUNT = 5000;

export default class TestimonialForm extends Component {
  render() {
    return <MyEnhancedForm showSuccessInfo={this.props.showSuccessInfo} handleSubmit={this.props.handleSubmit}/>
  }
}
const errMess = <T.span text={{key: "errMessage"}} />;
const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    nps: Yup.string().required(errMess),
    satisfaction: Yup.string().required(errMess),
    content: Yup.string().max(TEXT_LIMIT_AMOUNT, <span>{`Error: Character limit is ${TEXT_LIMIT_AMOUNT} characters`}</span>)
  }),
  mapPropsToValues: (props) => ({
    nps: '',
    satisfaction: '',
    content: '',
    notPublic: false
  }),
  handleSubmit: (values, { props, setSubmitting, setStatus } ) => {
    setStatus({ requestError: null })
    const inputData = {...values} //copy for now. check if can be potentially returned as reference
    props.handleSubmit(inputData)
  },
  displayName: 'MyForm',
});


class MyForm extends Component {
  state = {}

  handleNpsRating = (rating, e) => {
    this.props.setFieldValue('nps', rating)
  }
  handleSatisfactionRating = (rating, e) => {
    this.props.setFieldValue('satisfaction', rating)
  }
  showSuccessInfo = () => {
    this.props.showSuccessInfo(true)
  }

  handleContentChange = (e)=> {
    if(e.target.value.length <= TEXT_LIMIT_AMOUNT){
      this.props.handleChange(e);
    }
  }

  render(){
    const {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      isSubmitting,
      status,
    } = this.props

    if(isSubmitting) return <Spinner />
    const textCounter = values.content.length;
    return (
      <form onSubmit={handleSubmit}>
        <InputFeedback error={
          (touched.content && errors.content) ||
          (touched.nps && errors.nps) ||
          (touched.satisfaction && errors.satisfaction) ||
          (status && status.requestError ? status.requestError.toString() : null)
        }
        />
        <div className="recommend">
          <p>{T.translate("recommendation")}</p>
          <ul className="recommend__rating">
            <li className="thumb"><img src={unlike} alt='img' /></li>
              <NumericRating
                numberOfPositions={11}
                value={values.nps}
                onSelectedNumber={this.handleNpsRating}/>
            <li className="thumb"><img src={like} alt='img' /></li>
          </ul>
        </div>
        <div className="divider"/>
        <div className='stars-rating'>
          <p>{T.translate("satisfaction")}</p>
            <StarRating
              numberOfStars={5}
              value={values.satisfaction}
              onSelectedStar={this.handleSatisfactionRating}/>
        </div>
        <div className="divider"/>
        <div className="comment">
          <p>{T.translate("comment")}</p>
          <textarea
            id="content"
            className="textarea"
            value={values.content}
            type="textarea"
            onChange={this.handleContentChange}
            onBlur={handleBlur}
            placeholder={T.translate("commentHint")}
          />
          <div
            className="text-counter"
            style={{color: (textCounter >= TEXT_LIMIT_AMOUNT - 10) ? 'red': '#000'}}>
              {`${textCounter}/${TEXT_LIMIT_AMOUNT}`}
          </div>
        </div>
        <div className="agreement">
          <RadioButton
            id="notPublic"
            name="notPublic"
            type="checkbox"
            label={T.translate("unsubscribe")}
            value={values.notPublic}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
        <div className="valider">
          <button
            type="submit"
            name="submit"
            className="btn"
          >
            {T.translate("button")}
          </button>
        </div>
      </form>
    )
  }
}

const MyEnhancedForm = formikEnhancer(MyForm)



// WEBPACK FOOTER //
// ./src/components/TestimonialForm.js